<template>
  <v-alert
    v-for="bannerNotification in unreadBannerNotifications"
    :key="bannerNotification.id"
    closable
    :color="bannerNotification.type"
    :rounded="0"
    @click:close="markBannerNotificationAsRead(bannerNotification.id)"
  >
    <template #text>
      <div v-html="bannerNotification.message" />
    </template>
  </v-alert>
</template>

<script setup lang="ts">
const isAuthenticated = useIsAuthenticated();
const bannerNotificationStore = useBannerNotificationsStore();
const { fetchActiveBannerNotifications } = bannerNotificationStore;
const { activeBannerNotifications } = storeToRefs(bannerNotificationStore);
const readBannerNotificationIds = useCookie<number[]>('read-banners', { default: () => [] });
const unreadBannerNotifications = computed(() =>
  activeBannerNotifications.value.filter(bannerNotification => !readBannerNotificationIds.value.includes(bannerNotification.id)));

// Only try to get notifications if the user is authenticated
if (isAuthenticated.value) {
  fetchActiveBannerNotifications();
}

const markBannerNotificationAsRead = (bannerNotificationId: number) => {
  readBannerNotificationIds.value.push(bannerNotificationId);
};
</script>
